/**
 * Reads the capability names out of a Supabase auth `app_metadata` blob.
 * Returns an empty list when the metadata is missing or malformed; non-string entries are dropped.
 */
export function readCapabilities(appMetadata: unknown): string[] {
  if (typeof appMetadata !== 'object' || appMetadata == null || !('capabilities' in appMetadata)) {
    return []
  }
  const { capabilities } = appMetadata
  return Array.isArray(capabilities) ? capabilities.filter((value): value is string => typeof value === 'string') : []
}

/** Whether a Supabase auth `app_metadata` blob grants the named capability, such as `distribution`. */
export function hasCapability(appMetadata: unknown, capability: string): boolean {
  return readCapabilities(appMetadata).includes(capability)
}
